import { styled } from '@mui/material/styles';
import MuiLink from '@mui/material/Link';
import ImageBg from '../../../images/bg_ebook_menopausa.webp';
import ImageBgMobile from '../../../images/bg_ebook_menopausa_mobile.webp';

export const EbookRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#F4C3DE',
  backgroundImage: `url(${ImageBg})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '280px bottom',
  backgroundSize: 'contain',
  marginTop: theme.spacing(4),
  padding: theme.spacing(4),
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    backgroundImage: `url(${ImageBgMobile})`,
    backgroundPosition: 'right bottom'
  }
}));

export const HeaderRoot = styled('div')(({ theme }) => ({
  marginBottom: '20px',
  width: '310px',
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

export const ImageRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  img: {
    height: '140px'
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}));

export const CTARoot = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}));

export const Button = styled(MuiLink)(({ theme }) => ({
  fontWeight: '600',
  gap: '5px',
  borderBottom: `solid 4px ${theme.palette.colored.lilac}`,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  ':hover': {
    borderColor: `${theme.palette.colored.lilac}8c`
  }
}));
